// extracted by mini-css-extract-plugin
module.exports = {"main":"uqWaryfStIenV6NXy0Kkz","icon":"FBpBpjLOBSYZ-BA55oXK3","titulo":"_3C1zWFDle80-HFN4K8DzeF","subTitulo":"_1Z4_QeM2kvTL_CoKO1_NLI","back":"_2eIFsX6u2AH8CjF0FExkQm"};